module.exports = {
	"textures": [
		{
			"image": "BallSim04.png",
			"format": "RGBA8888",
			"size": {
				"w": 256,
				"h": 256
			},
			"scale": 1,
			"frames": [
				{
					"filename": "116.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 230,
						"y": 366,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "166.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 364,
						"y": 278,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 16,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "167.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 360,
						"y": 290,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 31,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "179.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 241,
						"y": 369,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 46,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 121,
						"y": 85,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 61,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "80.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 120,
						"y": 404,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 76,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "84.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 163,
						"y": 425,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 91,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "90.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 194,
						"y": 411,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 106,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "98.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 226,
						"y": 368,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 121,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 424,
						"y": 152,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 136,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "100.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 231,
						"y": 360,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 151,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "101.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 234,
						"y": 355,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 166,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "107.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 230,
						"y": 358,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 181,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "110.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 228,
						"y": 373,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 196,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "113.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 232,
						"y": 368,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 211,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 396,
						"y": 111,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 226,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "141.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 164,
						"y": 150,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 1,
						"y": 241,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "147.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 233,
						"y": 121,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 136,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "152.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 295,
						"y": 131,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 151,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "175.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 291,
						"y": 360,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 166,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 103,
						"y": 101,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 181,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 72,
						"y": 140,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 196,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 61,
						"y": 162,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 211,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 357,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 226,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "37.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 92,
						"y": 377,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 15,
						"y": 241,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "48.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 343,
						"y": 421,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 1,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "49.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 370,
						"y": 403,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 16,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 442,
						"y": 285,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 31,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "52.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 429,
						"y": 327,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 46,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "56.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 440,
						"y": 196,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 61,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "57.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 430,
						"y": 164,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 76,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "58.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 414,
						"y": 135,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 91,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "60.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 371,
						"y": 87,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 106,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "69.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 100,
						"y": 104,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 121,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "70.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 79,
						"y": 129,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 136,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "71.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 63,
						"y": 157,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 151,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "77.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 72,
						"y": 349,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 166,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "79.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 104,
						"y": 388,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 181,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 441,
						"y": 199,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 196,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "83.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 156,
						"y": 425,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 211,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "87.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 180,
						"y": 421,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 226,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 434,
						"y": 175,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 29,
						"y": 241,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "93.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 204,
						"y": 399,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 1,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "97.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 223,
						"y": 374,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 16,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "53.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 440,
						"y": 296,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 31,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "55.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 446,
						"y": 230,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 46,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "72.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 52,
						"y": 187,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 61,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 358,
						"y": 412,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 30,
						"y": 76,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 382,
						"y": 393,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 31,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "109.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 226,
						"y": 373,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 44,
						"y": 1,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "118.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 233,
						"y": 369,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 44,
						"y": 15,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 378,
						"y": 94,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 45,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "132.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 120,
						"y": 252,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 59,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "133.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 120,
						"y": 239,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 30,
						"y": 90,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "146.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 220,
						"y": 123,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 30,
						"y": 104,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "161.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 365,
						"y": 216,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 30,
						"y": 118,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 290,
						"y": 49,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 132,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "170.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 341,
						"y": 323,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 45,
						"y": 73,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "173.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 313,
						"y": 349,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 29,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "174.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 302,
						"y": 355,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 59,
						"y": 1,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "181.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 216,
						"y": 366,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 59,
						"y": 15,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "183.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 192,
						"y": 358,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 43,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "39.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 128,
						"y": 410,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 57,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "40.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 149,
						"y": 423,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 45,
						"y": 87,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "42.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 196,
						"y": 441,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 45,
						"y": 101,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "46.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 299,
						"y": 439,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 45,
						"y": 115,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "59.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 394,
						"y": 110,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 146,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "65.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 216,
						"y": 46,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 160,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "78.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 88,
						"y": 373,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 174,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "86.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 424,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 188,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "88.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 418,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 202,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "92.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 200,
						"y": 404,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 216,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "96.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 217,
						"y": 382,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 43,
						"y": 230,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "41.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 172,
						"y": 434,
						"w": 13,
						"h": 11
					},
					"frame": {
						"x": 43,
						"y": 244,
						"w": 13,
						"h": 11
					}
				},
				{
					"filename": "102.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 236,
						"y": 351,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 129,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "103.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 235,
						"y": 351,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 60,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "104.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 234,
						"y": 352,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 73,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "105.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 233,
						"y": 352,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 74,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "106.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 232,
						"y": 352,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 74,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "108.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 228,
						"y": 366,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 73,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 411,
						"y": 131,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 73,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "111.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 230,
						"y": 372,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 60,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "112.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 232,
						"y": 370,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 60,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "114.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 231,
						"y": 367,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 60,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "115.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 230,
						"y": 365,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 143,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "117.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 232,
						"y": 368,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 157,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "119.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 221,
						"y": 367,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 171,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "120.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 208,
						"y": 364,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 185,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "121.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 196,
						"y": 360,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 199,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "122.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 354,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 213,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "123.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 348,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 227,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "124.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 164,
						"y": 340,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 58,
						"y": 241,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "125.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 155,
						"y": 331,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 127,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "126.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 147,
						"y": 322,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 74,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "127.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 139,
						"y": 311,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 87,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "128.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 133,
						"y": 300,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 88,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "129.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 128,
						"y": 289,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 88,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "130.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 124,
						"y": 277,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 87,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "131.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 122,
						"y": 264,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 87,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "134.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 122,
						"y": 226,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 74,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "135.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 124,
						"y": 214,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 74,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "136.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 128,
						"y": 202,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 74,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "137.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 133,
						"y": 190,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 141,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "138.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 139,
						"y": 179,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 155,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "139.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 147,
						"y": 169,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 169,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 359,
						"y": 79,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 183,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "140.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 155,
						"y": 159,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 197,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "142.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 143,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 211,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "143.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 136,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 225,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "144.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 196,
						"y": 131,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 72,
						"y": 239,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "145.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 208,
						"y": 126,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 127,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "148.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 246,
						"y": 121,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 88,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "149.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 258,
						"y": 122,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 101,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 338,
						"y": 66,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 102,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "150.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 271,
						"y": 124,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 102,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "151.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 283,
						"y": 127,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 101,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "153.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 306,
						"y": 137,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 101,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "154.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 317,
						"y": 144,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 88,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "155.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 327,
						"y": 152,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 88,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "156.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 336,
						"y": 161,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 88,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "157.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 344,
						"y": 170,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 141,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "158.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 351,
						"y": 181,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 155,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "159.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 357,
						"y": 192,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 169,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 315,
						"y": 56,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 183,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "160.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 362,
						"y": 204,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 197,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "162.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 368,
						"y": 228,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 211,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "163.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 369,
						"y": 241,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 225,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "164.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 369,
						"y": 254,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 86,
						"y": 239,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "165.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 367,
						"y": 266,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 127,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "168.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 355,
						"y": 302,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 102,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "169.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 349,
						"y": 313,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 115,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "171.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 333,
						"y": 333,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 116,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "172.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 324,
						"y": 341,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 116,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "176.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 279,
						"y": 365,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 115,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "177.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 368,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 115,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "178.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 254,
						"y": 369,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 102,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 265,
						"y": 45,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 102,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "180.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 229,
						"y": 369,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 102,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "182.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 204,
						"y": 363,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 141,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "184.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 181,
						"y": 352,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 155,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "185.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 171,
						"y": 345,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 169,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 403,
						"y": 370,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 183,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 188,
						"y": 52,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 197,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 164,
						"y": 60,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 211,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 142,
						"y": 72,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 225,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 86,
						"y": 120,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 100,
						"y": 239,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "45.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 274,
						"y": 445,
						"w": 13,
						"h": 11
					},
					"frame": {
						"x": 130,
						"y": 1,
						"w": 13,
						"h": 11
					}
				},
				{
					"filename": "64.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 250,
						"y": 45,
						"w": 13,
						"h": 11
					},
					"frame": {
						"x": 145,
						"y": 1,
						"w": 13,
						"h": 11
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 52,
						"y": 186,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 160,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 421,
						"y": 344,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 130,
						"y": 14,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 48,
						"y": 289,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 144,
						"y": 14,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 55,
						"y": 313,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 174,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 65,
						"y": 336,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 188,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "38.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 109,
						"y": 395,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 202,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "47.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 323,
						"y": 431,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 216,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "50.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 394,
						"y": 381,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 230,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 47,
						"y": 211,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 244,
						"y": 1,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "51.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 414,
						"y": 356,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 158,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "61.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 344,
						"y": 70,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 130,
						"y": 28,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "62.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 315,
						"y": 56,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 144,
						"y": 28,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "67.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 152,
						"y": 66,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 172,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "68.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 124,
						"y": 83,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 186,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 445,
						"y": 225,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 200,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "76.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 57,
						"y": 320,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 214,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "85.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 169,
						"y": 425,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 228,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "89.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 191,
						"y": 415,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 242,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "91.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 197,
						"y": 408,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 158,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "94.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 208,
						"y": 395,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 129,
						"y": 42,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "95.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 213,
						"y": 389,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 143,
						"y": 42,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "99.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 229,
						"y": 365,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 172,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 239,
						"y": 45,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 186,
						"y": 29,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 213,
						"y": 47,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 200,
						"y": 29,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "43.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 222,
						"y": 446,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 214,
						"y": 29,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "44.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 248,
						"y": 447,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 228,
						"y": 29,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "63.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 283,
						"y": 48,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 242,
						"y": 29,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "66.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 183,
						"y": 54,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 186,
						"y": 42,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "81.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 419,
						"w": 12,
						"h": 10
					},
					"frame": {
						"x": 157,
						"y": 43,
						"w": 12,
						"h": 10
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 44,
						"y": 237,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 171,
						"y": 43,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 45,
						"y": 263,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 157,
						"y": 55,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 434,
						"y": 316,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 129,
						"y": 56,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "54.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 446,
						"y": 264,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 142,
						"y": 56,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 446,
						"y": 253,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 200,
						"y": 42,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "73.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 45,
						"y": 220,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 184,
						"y": 55,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "74.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 44,
						"y": 253,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 170,
						"y": 57,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "75.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 48,
						"y": 287,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 155,
						"y": 69,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "82.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 149,
						"y": 425,
						"w": 11,
						"h": 11
					},
					"frame": {
						"x": 129,
						"y": 70,
						"w": 11,
						"h": 11
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:5d1b061f857ba974f1ea3527822695af:1afee641cbb743f887378cf7b555b8f1:a4322d45a839f040234778a3da844da8$"
	}
}
;